import { CashRegisterReportRequestModel } from '../api/models/CashRegisterReportRequestModel';
import { CashRegisterReportFormModel } from '../models';

export const dataFormToRequest = (
  data: CashRegisterReportFormModel
): CashRegisterReportRequestModel => ({
  from: data.from,
  to: data.to,
  cash_register_ids: data.cash_register_ids,
  cashier_ids: data.cashier_ids,
  operation_id: data.operation_id,
  file_type: data?.file_type,
  with_details: data.with_details,
  with_exchange: data.with_exchange,
  closing_groupedby_group: data?.closing_groupedby_group,
});
